module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-red-f5ccc5.svg";